import {Accordion, AccordionSummary, Typography} from "@material-ui/core"
import {HighlightOff as DigitalCommConsentDeniedIcon} from "@material-ui/icons"
import React from "react"
import styled from "styled-components"

import {CustomerDigitalCommunicationConsentActivityPayload} from "@indebted/api"

function DigitalCommunicationConsentDeniedActivity(
	panelId: number,
	{
		Title,
		HappenedAt,
	}: {Title: string; HappenedAt: string; Payload: CustomerDigitalCommunicationConsentActivityPayload},
	expanded: boolean,
	handleExpand: (panelID: number) => void,
	classes: {summary: string},
) {
	return (
		<AccordionNoContent expanded={false}>
			<AccordionSummary>
				<DigitalCommConsentDeniedIcon color="primary" />
				<Typography className={classes.summary}>
					{" "}
					<b>{Title}</b> - {HappenedAt}
				</Typography>
			</AccordionSummary>
		</AccordionNoContent>
	)
}

const AccordionNoContent = styled(Accordion)`
	.MuiAccordionSummary-content {
		cursor: default;
	}
`

export {DigitalCommunicationConsentDeniedActivity}
